// ANX-118 — логика пикера тегов в диалоге: фильтрация существующих + решение
// «можно создать новый» (когда введён непустой текст без точного совпадения).

/** Палитра для авто-цвета нового тега, созданного на лету из диалога. */
export const TAG_PALETTE = [
  '#2563eb',
  '#16a34a',
  '#d97706',
  '#dc2626',
  '#7c3aed',
  '#0891b2',
  '#db2777',
  '#64748b',
] as const;

/** Детерминированный цвет нового тега по числу уже существующих. */
export function pickTagColor(existingCount: number): string {
  const i = ((existingCount % TAG_PALETTE.length) + TAG_PALETTE.length) % TAG_PALETTE.length;
  return TAG_PALETTE[i];
}

export interface TagPickerState<T> {
  /** Тримленный ввод. */
  name: string;
  /** Существующие теги, подходящие под ввод (или все, если ввод пуст). */
  filtered: T[];
  /** Показать кнопку «Создать»: непустой ввод без точного совпадения по имени. */
  canCreate: boolean;
}

export function tagPickerState<T extends { name: string }>(
  all: T[],
  filter: string,
): TagPickerState<T> {
  const name = filter.trim();
  const lc = name.toLowerCase();
  const filtered = name === '' ? all : all.filter((t) => t.name.toLowerCase().includes(lc));
  const exact = all.some((t) => t.name.toLowerCase() === lc);
  return { name, filtered, canCreate: name !== '' && !exact };
}
